import clsx from 'clsx';
import { useState } from 'react';
import styles from './hamburgerMenu.module.css';

const HamburgerMenu = ({ className }: { className?: string }) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      role="button"
      className={clsx(styles.hamburger, className)}
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
    >
      <span className={clsx({ [styles.hover]: hover })} />
      <span className={clsx({ [styles.hover]: hover })} />
      <span className={clsx({ [styles.hover]: hover })} />
    </div>
  );
};

export default HamburgerMenu;
